/**
 * VENDOR MODULES
 */
import React from 'react';
import { withTranslation } from "react-i18next";

/**
 * Player modules routes
 */
import AppRoutes from './AppRoutes';

function App(props) {
  return (
    <div className="players-wrapper">
      <AppRoutes {...props} />
    </div>
  );
}

export default withTranslation()(App);

